import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalFilledShieldIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M2 3.4L11.6 1L21.2 3.4V14.383C21.2 15.7622 20.4895 17.044 19.32 17.775L11.6 22.6L3.88 17.775C2.71048 17.044 2 15.7622 2 14.383V3.4Z",
			fill: "#1F3B44",
			stroke: "#1F3B44",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7087 13.238V5.96862C10.7087 5.43332 11.1421 5 11.6774 5C12.2127 5 12.646 5.43332 12.646 5.96862V13.238C12.646 13.7733 12.2127 14.2066 11.6774 14.2066C11.1421 14.2066 10.7087 13.7733 10.7087 13.238Z",
			fill: "#FCEED5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6463 16.6304C12.6463 17.1657 12.2123 17.5996 11.677 17.5996C11.1417 17.5996 10.7078 17.1657 10.7078 16.6304C10.7078 16.0951 11.1417 15.6611 11.677 15.6611C12.2123 15.6611 12.6463 16.0951 12.6463 16.6304Z",
			fill: "#FCEED5"
		})
	]
});
const ForwardRef = forwardRef(SvgPortalFilledShieldIcon);
const Memo = memo(ForwardRef);
export default Memo;
